import styled, { css } from 'styled-components'

import { Button } from 'common-components'

export const ExportButtonWrapper = styled(Button)<{ $isDisabled: boolean }>`
  margin-right: 24px;
  ${({ $isDisabled }) =>
    $isDisabled &&
    css`
      opacity: 0.5;
      pointer-events: none;
      cursor: not-allowed;
    `}
`
